import { DraftAppointment, DraftAppointmentCancellationReason } from '~/graphql/generated/graphql';

type CanceledByType = '薬局' | '医療機関' | '患者' | '不明';

export const translateReason = (
  draftAppointment: Pick<DraftAppointment, 'status' | 'cancellationReason'>,
): { canceledBy: CanceledByType; detail: string } => {
  if (draftAppointment.status === 'not_prescribed') {
    return { canceledBy: '医療機関', detail: '処方箋発行なし' };
  }

  switch (draftAppointment.cancellationReason) {
    case 'prov':
      return { canceledBy: '薬局', detail: 'お薬の在庫がなかった' };
    case 'pat':
      return { canceledBy: '薬局', detail: '患者と連絡が取れない' };
    case 'pat_cpp':
      return { canceledBy: '患者', detail: '患者からキャンセルされた' };
    case 'oth_mu':
      return { canceledBy: '薬局', detail: '医療機関が処方箋を発行しなかった' };
    case 'other':
      return { canceledBy: '薬局', detail: 'その他' };
    default:
      return { canceledBy: '不明', detail: '不明' };
  }
};

export const cancellationReasons: Record<string, DraftAppointmentCancellationReason[]> = {
  ['available']: ['oth_mu', 'prov', 'other'],
  ['wait_for_booking']: ['pat', 'prov', 'other'],
};
